<template>
  <a-card :bordered="false">
    <a-steps class="steps" :current="currentTab">
      <a-step v-for="item in steps" :key="item.title" :title="item.title">
      </a-step>
    </a-steps>
    <div class="content">
      <div v-if="currentTab == 0">
        <a-form style="max-width: 500px; margin: 80px auto 0;">
          <a-form-item :label="$t('label.company')"  :labelCol="{span: 5}" :wrapperCol="{span: 19}">
            <j-search-select-tag ref="companyInfo" type="list" v-model="form.company" @change="companyChange" :triggerChange="true" dict="view_sys_organization,CONCAT(org_code((comma))depart_name),org_def_code,org_category='1' and '((sysCode))' like CONCAT(org_def_code((comma))'*') and length(org_def_code)=6 and del_flag = '0'" :placeholder="$t('label.pleaseSelectCompany')" />
          </a-form-item>
          <a-form-item label="账期" :labelCol="{span: 5}" :wrapperCol="{span: 19}">
            <j-dict-select-tag type="list" v-model="form.period" :dictCode="accountPeriodDict" placeholder="请选择账期" />
          </a-form-item>
          <a-form-item :wrapperCol="{span: 19, offset: 5}">
            <a-button type="primary" @click="nextStep">下一步</a-button>
          </a-form-item>
        </a-form>
      </div>
      <div v-if="currentTab != 0 && currentTab != this.steps.length-1">
        公司：{{form.company}}-{{companyName}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;账期：{{form.period}}
        <a-form style="max-width: 500px; margin: 40px auto 0;">
          <a-form-item v-for="item in stepLabels" :key="item.key" :label="item.text" :labelCol="{span: 8}" :wrapperCol="{span: 16}">
            <a-tooltip>
              <template slot='title'>
                {{item.title}}
              </template>
              <a-icon v-if="item.status == '30'" type="check-circle" style="color:green;" />
              <a-icon v-else-if="item.status == '20'" type="redo" style="color:blue;" spin />
              <a-icon v-else-if="item.status == '40'" type="close-circle" style="color:red;" />
              <a-icon v-else type="question-circle" style="color:orange;" />
            </a-tooltip>
          </a-form-item>
          <a-form-item :wrapperCol="{span: 19, offset: 5}">
            <a-button :disabled="retryLoading" @click="prevStep">上一步</a-button>
            <a-button style="margin-left: 8px" :loading="retryLoading" @click="retry">执行</a-button>
            <a-button style="margin-left: 8px" type="primary" :disabled="retryLoading" @click="nextStep">下一步</a-button>
          </a-form-item>
        </a-form>
      </div>
      <div v-if="currentTab == this.steps.length-1" style="margin: 40px auto 0;">
        <a-table :columns="columns" bordered :pagination="false" :data-source="dataSource"></a-table>
        <a-row style="margin-top: 20px;">
          <a-col align="right">
            <a-button type="primary" :loading="retryLoading" @click="generate">生成凭证</a-button>
            <a-button style="margin-left: 8px" :loading="retryLoading" @click="submit">凭证回传</a-button>
            <a-button style="margin-left: 8px" :disabled="retryLoading" @click="finish">完成</a-button>
          </a-col>
        </a-row>
      </div>
    </div>
  </a-card>
</template>

<script>
import { ajaxGetDictItems } from '@/api/api'
import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
import JDictSelectTag from '@/components/dict/JDictSelectTag'
import { postJsonAction, getAction } from '@/api/manage'

export default {
  name: "costStepForm",
  components: {
    JSearchSelectTag,
    JDictSelectTag,
  },
  data() {
    return {
      currentTab: 0,
      accountPeriodDict: null,
      form: {},
      steps: [],
      stepLabels: [],
      retryLoading: false,
      columns: [
          {
          title: '凭证编码',
          dataIndex: 'accountCode',
        },
        {
          title: '摘要',
          dataIndex: 'docTitle',
        },
        // {
        //   title: '方向',
        //   dataIndex: 'key2',
        // },
        {
          title: '科目代码',
          dataIndex: 'ledgerAccount',
        },
        {
          title: '科目名称',
          dataIndex: 'accountName',
        },
        {
          title: '金额',
          dataIndex: 'amount',
        },
        {
          title: '过账码',
          dataIndex: 'postCode',
        },
        {
          title: '成本中心',
          dataIndex: 'costCenter',
        },
        {
          title: '内部订单',
          dataIndex: 'orderCode',
        },
        {
          title: '物料',
          dataIndex: 'mmCode',
        },
        // {
        //   title: '客户',
        //   dataIndex: 'customerCode',
        // },
        {
          title: '凭证号',
          dataIndex: 'docNo',
        },
      ],
      dataSource: [],
      url: {
        getSyncInterface: '/cost/sync/getSyncInterface',
      },
      companyName: ''
    }
  },
  created() {
    // 接口：
    this.initStep()
  },
  methods: {
    initStep() {
      ajaxGetDictItems('cost_account_step', null).then((res) => {
        if (res.success) {
          this.steps = res.result;
        }
      })
    },
    companyChange(e) {
      console.log(this.$refs.companyInfo.options)
      this.$refs.companyInfo.options.map(item => {
        if (item.value == e) {
          this.companyName = item.title
        }
      })
      this.accountPeriodDict = "efs_sys_account_period,period_code,period_code,status='B' AND valid_flag = 'Y' AND del_flag = 'N' AND company_code = '" + e + "' order by period_code desc"
    },
    getLabel() {
      console.log(this.form)
      let url = '/cost/efsCostMain/getCostAccountSteps'
      let _request = [{
        company: this.form.company,
        period: this.form.period,
        step: this.steps[this.currentTab]['value'],
      }]
      postJsonAction(url, JSON.stringify(_request)).then(res => {
        if (res.success) {
          if (this.currentTab < this.steps.length-1) {
            this.stepLabels = res.result
            this.stepLabels && this.stepLabels.length && this.stepLabels.map(item => {
              item.status = 10
              item.title=item.text
            })
          } else {
            this.dataSource = res.result.records
          }
        }
      })
    },
    nextStep() {
      if (this.form.company && this.form.period) {
        this.currentTab += 1
        this.getLabel()
      }
    },
    syncInterface() {
      this.retryLoading = true
      let _request = {
        companyCode: this.form.company,
        postDate: this.form.period,
      }
      getAction(this.url.getSyncInterface, _request).then(res => {
        if (res.success) {
          this.stepLabels && this.stepLabels.length && this.stepLabels.map((item, index) => {
            item.status = res.result[index].status
            item.title = res.result[index].msg
          })
          this.$forceUpdate()
        }
        this.retryLoading = false
      }).catch(err => {
        this.retryLoading = false
      })
    },
    prevStep() {
      this.currentTab -= 1
      this.getLabel()
    },
    retry() {
      if (this.currentTab == 1) {
        this.syncInterface()
      } else {
        this.retryLoading = true
        this.stepLabels.map(item => {
          item.status = 20
        })
        console.log(this.form)
        let url = '/cost/efsCostMain/runCostAccount'
        let _request = [{
          company: this.form.company,
          period: this.form.period,
          step: this.steps[this.currentTab]['value'],
        }]
        postJsonAction(url, JSON.stringify(_request)).then(res => {
          this.retryLoading = false
          if (res.success) {
            if (this.currentTab <  this.steps.length) {
              this.stepLabels.map(item => {
                item.status = 30
                item.title=res.message
              })
            } else {
              this.dataSource = res.result.records
            }
          } else {
            this.stepLabels.map(item => {
              item.status = 40
              item.title=res.message
            })
          }
        }).catch(err => {
          this.retryLoading = false
        })
      }
    },
    finish() {
      this.currentTab = 0
    },
    generate() {
      this.retryLoading = true
      this.stepLabels.map(item => {
        item.status = 20
      })
      {
        console.log(this.form)
        let url = '/cost/efsCostMain/runCostAccount'
        let _request = [{
          company: this.form.company,
          period: this.form.period,
          step: this.steps[this.currentTab]['value']+"_GEN",
        }]
        postJsonAction(url, JSON.stringify(_request)).then(res => {
          this.retryLoading = false
          if (res.success) {
            this.dataSource = res.result.records;
          }
          else
          {
            this.$message.error('生成失败:'+res.message);
          }
        }).catch(err => {
          this.retryLoading = false
        })
      }
    },
    submit() {
      this.retryLoading = true
      this.stepLabels.map(item => {
        item.status = 20
      })
      console.log(this.form)
      let url = '/cost/efsCostMain/runCostAccount'
      let _request = [{
        company: this.form.company,
        period: this.form.period,
        step: this.steps[this.currentTab]['value']+"_CMT",
      }]
      postJsonAction(url, JSON.stringify(_request)).then(res => {
        this.retryLoading = false
        if (res.success) {
          this.$message.success('同步成功');
        }
        else
        {
          this.$message.error('同步失败:'+res.message);
        }
      }).catch(err => {
        this.retryLoading = false
      })
    },
  }
}
</script>

<style lang="less" scoped>
.steps {
  margin: 16px auto;
}
</style>